// File: src/pages/student/StudentCareerPage.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import logoImg from '../../assets/avt.png';

// --- ICONS ---
const IconSchool = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 10v6M2 10l10-5 10 5-10 5z"/><path d="M6 12v5c3 3 9 3 12 0v-5"/></svg>;
const IconSparkles = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z"/></svg>;
const IconArrowLeft = () => <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="m12 19-7-7 7-7"/><path d="M19 12H5"/></svg>;

// --- DỮ LIỆU GỢI Ý ---
const INTEREST_TAGS = [
    "🎨 Thích vẽ/Thiết kế", "💻 Mê công nghệ", "🗣️ Hướng ngoại", 
    "🏠 Hướng nội", "🧮 Giỏi tính toán", "✍️ Thích viết lách", 
    "🛠️ Thích lắp ráp", "🌍 Thích ngoại ngữ", "🎵 Yêu âm nhạc", 
    "🏥 Quan tâm y tế", "📈 Thích kinh doanh", "🔍 Thích nghiên cứu"
];

export default function StudentCareerPage() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState(null);
    const [activeTab, setActiveTab] = useState('input');
    const [provinces, setProvinces] = useState([]);
    const [errors, setErrors] = useState({}); // State lưu lỗi validation

    // Form State
    const [formData, setFormData] = useState({
        gradeLevel: '12',
        location: '',
        financialCapability: 'Trung bình',
        interests: '',
        academicScores: {
            math: '', literature: '', english: '', 
            physics: '', chemistry: '', biology: '', 
            history: '', geography: ''
        }
    });

    const API_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001';
    useEffect(() => {
        const initData = async () => {
            // Fetch Tỉnh
            try {
                const provRes = await fetch('https://provinces.open-api.vn/api/?depth=1');
                if (provRes.ok) setProvinces(await provRes.json());
            } catch (e) { console.error("Lỗi tỉnh:", e); }

            // Fetch Profile & Kết quả cũ
            const token = localStorage.getItem('skillmatch_token');
            if (token) {
                try {
                    const res = await fetch(`${API_URL}/api/student/profile`, {
                        headers: { 'x-auth-token': token }
                    });
                    if (res.ok) {
                        const data = await res.json();
                        
                        // Fill lại form
                        setFormData(prev => ({
                            ...prev,
                            gradeLevel: data.gradeLevel || '12',
                            location: data.location || '',
                            financialCapability: data.financialCapability || 'Trung bình',
                            interests: data.interests || '',
                            academicScores: { ...prev.academicScores, ...data.academicScores }
                        }));

                        // ✅ QUAN TRỌNG: Nếu đã có kết quả lần trước, hiển thị luôn
                        if (data.latestConsultation && Object.keys(data.latestConsultation).length > 0) {
                            console.log("🔍 Tìm thấy kết quả cũ, đang hiển thị...");
                            setResult(data.latestConsultation);
                            setActiveTab('result'); // Chuyển ngay sang tab Result
                        }
                    }
                } catch (err) {
                    console.error("Lỗi tải hồ sơ:", err);
                }
            }
        };
        initData();
    }, []);

    // 2. HANDLERS
    const handleScoreChange = (subject, value) => {
        // Chỉ cho nhập số từ 0-10
        if (value < 0 || value > 10) return;
        setFormData(prev => ({
            ...prev,
            academicScores: { ...prev.academicScores, [subject]: value }
        }));
    };

    const addInterestTag = (tag) => {
        setFormData(prev => {
            const current = prev.interests;
            // Nếu đã có tag này thì không thêm nữa
            if (current.includes(tag)) return prev;
            const newInterests = current ? `${current}, ${tag}` : tag;
            return { ...prev, interests: newInterests };
        });
        // Xóa lỗi nếu có
        if (errors.interests) setErrors(prev => ({ ...prev, interests: null }));
    };

    const validateForm = () => {
        const newErrors = {};
        if (!formData.location) newErrors.location = "Vui lòng chọn khu vực ưu tiên.";
        if (!formData.interests || formData.interests.length < 10) newErrors.interests = "Hãy nhập sở thích chi tiết hơn (ít nhất 10 ký tự).";
        
        // Kiểm tra ít nhất 3 môn có điểm
        const scores = Object.values(formData.academicScores).filter(s => s !== '');
        if (scores.length < 3) newErrors.scores = "Vui lòng nhập điểm ít nhất 3 môn chính.";

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleConsult = async () => {
        if (!validateForm()) return;

        setLoading(true);
        try {
            const token = localStorage.getItem('skillmatch_token');
            if (!token) {
                alert("Bạn cần đăng nhập!");
                navigate('/login');
                return;
            }

            // Clean data ở frontend (dự phòng)
            const cleanScores = Object.keys(formData.academicScores).reduce((acc, key) => {
                const value = formData.academicScores[key];
                acc[key] = (value === '' || value === null) ? 0 : Number(value);
                return acc;
            }, {});

            const payload = { ...formData, academicScores: cleanScores };

            const res = await fetch(`${API_URL}/api/student/consult`, {
                method: 'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    'x-auth-token': token // Header chuẩn
                },
                body: JSON.stringify(payload)
            });

            const data = await res.json(); // Đọc JSON trước

            if (!res.ok) {
                // ✅ HIỂN THỊ LỖI THẬT TỪ SERVER
                throw new Error(data.message || "Lỗi không xác định từ server");
            }

            setResult(data);
            setActiveTab('result');

        } catch (error) {
            console.error("Lỗi Frontend:", error);
            // Alert chính xác lỗi nhận được
            alert(`Lỗi: ${error.message}`); 
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="student-page-container">
            {/* BACKGROUND (Optimized for performance) */}
            <div className="blob blob-1"></div>
            <div className="blob blob-2"></div>

            {/* HEADER & NAV */}
            <div className="top-nav">
                <button className="back-btn-modern" onClick={() => navigate('/student')}>
                    <div className="icon-circle"><IconArrowLeft /></div>
                    <span>Dashboard</span>
                </button>
            </div>

            <header className="student-header animate-fade-down">
                <div className="flex justify-center mb-6">
                                                <img
                                                    src={logoImg}
                                                    alt="SkillMatch Logo"
                                                    className="h-24 w-auto object-contain drop-shadow-md hover:scale-105 transition-transform"
                                                />
                                            </div>
                <h1 className="student-title">
                    Hồ Sơ <span className="highlight">Định Hướng</span>
                </h1>
                <p className="subtitle">Nhập điểm số & sở thích để AI vẽ lối đi riêng cho bạn ✨</p>
            </header>

            <main className="student-layout-content animate-fade-up">
                {/* TABS */}
                {result && (
                    <div className="tabs-container">
                        <button 
                            className={`tab-btn ${activeTab === 'input' ? 'active' : ''}`}
                            onClick={() => setActiveTab('input')}
                        >
                            ✏️ Cập nhật hồ sơ
                        </button>
                        <button 
                            className={`tab-btn ${activeTab === 'result' ? 'active' : ''}`}
                            onClick={() => setActiveTab('result')}
                        >
                            🔮 Kết quả AI
                        </button>
                    </div>
                )}

                {/* --- INPUT FORM --- */}
                <div className={`form-section ${activeTab === 'input' ? 'block' : 'hidden'}`}>
                    <div className="glass-card main-form-card">
                        
                        {/* 1. INFO */}
                        <div className="section-block">
                            <h3 className="section-label">👋 Thông tin cơ bản</h3>
                            <div className="grid-2">
                                <div className="input-wrapper">
                                    <label>Lớp học hiện tại</label>
                                    <select 
                                        value={formData.gradeLevel}
                                        onChange={e => setFormData({...formData, gradeLevel: e.target.value})}
                                    >
                                        <option value="10">Lớp 10</option>
                                        <option value="11">Lớp 11</option>
                                        <option value="12">Lớp 12 (Sắp thi ĐH)</option>
                                        <option value="University">Đại học (Định hướng lại)</option>
                                    </select>
                                </div>
                                <div className="input-wrapper">
                                    <label>Ngân sách học tập / năm</label>
                                    <select
                                        value={formData.financialCapability}
                                        onChange={e => setFormData({...formData, financialCapability: e.target.value})}
                                    >
                                        <option value="Thấp">Dưới 20 triệu (Ưu tiên công lập)</option>
                                        <option value="Trung bình">20 - 50 triệu (Đại học tự chủ)</option>
                                        <option value="Cao">Trên 50 triệu (Quốc tế, Dân lập VIP)</option>
                                    </select>
                                </div>
                            </div>
                            
                            <div className="input-wrapper mt-4">
                                <label>Khu vực ưu tiên học <span className="required">*</span></label>
                                <select 
                                    value={formData.location}
                                    onChange={e => {
                                        setFormData({...formData, location: e.target.value});
                                        if(errors.location) setErrors({...errors, location: null});
                                    }}
                                    className={errors.location ? 'input-error' : ''}
                                >
                                    <option value="">-- Chọn Tỉnh/Thành phố --</option>
                                    {provinces.map(prov => (
                                        <option key={prov.code} value={prov.name}>{prov.name}</option>
                                    ))}
                                </select>
                                {errors.location && <p className="error-msg">{errors.location}</p>}
                            </div>

                            <div className="input-wrapper mt-4">
                                <label>Sở thích & Tính cách <span className="required">*</span></label>
                                <textarea 
                                    rows="3"
                                    placeholder="Mô tả bản thân: Hướng nội, thích vẽ, giỏi logic, ghét tính toán..."
                                    value={formData.interests}
                                    onChange={e => {
                                        setFormData({...formData, interests: e.target.value});
                                        if(errors.interests) setErrors({...errors, interests: null});
                                    }}
                                    className={errors.interests ? 'input-error' : ''}
                                ></textarea>
                                {errors.interests && <p className="error-msg">{errors.interests}</p>}
                                
                                {/* TAGS GỢI Ý */}
                                <div className="tags-suggestion">
                                    <p>Gợi ý (Bấm để chọn):</p>
                                    <div className="tags-list">
                                        {INTEREST_TAGS.map((tag, idx) => (
                                            <button 
                                                key={idx} 
                                                className="tag-btn"
                                                onClick={() => addInterestTag(tag)}
                                            >
                                                {tag} +
                                            </button>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* 2. SCORES */}
                        <div className="section-block">
                            <h3 className="section-label">📊 Bảng điểm (Nhập 0-10)</h3>
                            {errors.scores && <p className="error-msg mb-2">{errors.scores}</p>}
                            <div className="score-grid">
                                {['math', 'physics', 'chemistry', 'literature', 'english', 'history', 'geography', 'biology'].map((subj) => (
                                    <div key={subj} className="score-item">
                                        <span className="score-label">{getSubjectEmoji(subj)} {getSubjectName(subj)}</span>
                                        <input 
                                            type="number" 
                                            placeholder="..." 
                                            value={formData.academicScores[subj]}
                                            onChange={e => handleScoreChange(subj, e.target.value)}
                                            className="score-input-field"
                                            min="0" max="10" step="0.1"
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* SUBMIT BUTTON */}
                        <div className="action-area">
                            <button className="btn-magic" onClick={handleConsult} disabled={loading}>
                                {loading ? (
                                    <span className="flex items-center gap-2"><div className="spinner"></div> AI Đang Phân Tích...</span>
                                ) : (
                                    <>
                                        <IconSparkles /> Phân Tích Lộ Trình Ngay
                                    </>
                                )}
                            </button>
                        </div>
                    </div>
                </div>

                {/* --- RESULT SECTION (Giữ nguyên logic hiển thị) --- */}
                {result && (
                    <div className={`result-section ${activeTab === 'result' ? 'block' : 'hidden'}`}>
                        {/* 1. KHỐI PHÂN TÍCH */}
                        <div className="glass-card analyze-card mb-6">
                            <div className="analyze-header">
                                <span className="emoji-icon">🧠</span>
                                <div>
                                    <h3>Phân tích năng lực</h3>
                                    <p>{result.analysis?.academic_strength}</p>
                                </div>
                            </div>
                            <div className="tags-container">
                                <span className="tag-label">Khối thi tiềm năng:</span>
                                {result.analysis?.best_blocks?.map(block => (
                                    <span key={block} className="tag-block">{block}</span>
                                ))}
                            </div>
                        </div>

                        {/* 2. NGÀNH NGHỀ */}
                        <h3 className="section-header-text">🚀 Ngành nghề phù hợp</h3>
                        <div className="cards-grid">
                            {result.career_suggestions?.map((career, idx) => (
                                <div key={idx} className="career-card">
                                    <div className="card-top">
                                        <div className="card-icon-circle">💼</div>
                                        {career.trend === 'Cao' && <span className="trend-badge">🔥 Hot Trend</span>}
                                    </div>
                                    <h4>{career.name}</h4>
                                    <p className="reason">"{career.reason}"</p>
                                    <div className="card-divider"></div>
                                    <div className="card-footer">
                                        <span className="salary-text">💰 Lương: {career.average_salary}</span>
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* 3. ĐẠI HỌC */}
                        <h3 className="section-header-text mt-8">🏫 Trường Đại học đề xuất</h3>
                        <div className="uni-list-container">
                            {result.university_recommendations?.map((uni, idx) => (
                                <div key={idx} className="uni-item">
                                    <div className="uni-icon">🎓</div>
                                    <div className="uni-content">
                                        <h4>{uni.name}</h4>
                                        <p className="uni-detail">Ngành: <strong>{uni.major}</strong> ({uni.block})</p>
                                        <div className="uni-badges">
                                            <span className="badge-gray">💵 {uni.tuition_level}</span>
                                            <span className="badge-blue">🎯 Điểm chuẩn: {uni.safe_score}</span>
                                        </div>
                                    </div>
                                    <div className={`uni-chance-tag ${getChanceClass(uni.chance)}`}>
                                        {uni.chance}
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* 4. LỘ TRÌNH */}
                        <div className="roadmap-container mt-8">
                            <h3 className="roadmap-title">🗺️ Action Plan: Việc cần làm ngay</h3>
                            <ul className="roadmap-list">
                                {result.roadmap_next_steps?.map((step, idx) => (
                                    <li key={idx}>
                                        <span className="check-icon">✅</span>
                                        <span>{step}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                )}
            </main>

            {/* --- STYLES --- */}
            <style>{`
                :root {
                    --primary: #DB2777; /* Hồng đậm */
                    --secondary: #7C3AED; /* Tím */
                    --bg-soft: #FFF5F7;
                    --text-main: #1F2937;
                    --text-sub: #4B5563;
                    --glass-bg: rgba(255, 255, 255, 0.7); /* Giảm độ đục để mượt hơn */
                    --glass-border: rgba(255, 255, 255, 0.8);
                }

                /* 1. OPTIMIZED BACKGROUND (Fix Lag) */
                .student-page-container {
    width: 100%;
    min-height: 100vh;
    height: auto; /* ✅ Bắt buộc để nội dung dài ra thì container dài theo */
    background: linear-gradient(135deg, #FDF2F8 0%, #EEF2FF 100%);
    font-family: 'Inter', sans-serif;
    position: relative;
    padding: 80px 20px 60px;
    color: var(--text-main);
    
    /* Chỉ ẩn thanh cuộn ngang, nhưng phải đảm bảo trục dọc luôn mở */
    overflow-x: hidden; 
    overflow-y: visible; 
}
                /* Sử dụng transform translate3d để ép GPU render, giảm lag */
                .blob {
                    position: absolute;
                    border-radius: 50%;
                    filter: blur(60px); /* Giảm blur radius */
                    opacity: 0.4;
                    z-index: 0;
                    will-change: transform; /* Báo trình duyệt tối ưu */
                }
                .blob-1 {
                    top: -100px; left: -100px; width: 400px; height: 400px;
                    background: #FBCFE8;
                    animation: floatBlob 20s infinite ease-in-out alternate;
                }
                .blob-2 {
                    bottom: -100px; right: -100px; width: 500px; height: 500px;
                    background: #C4B5FD;
                    animation: floatBlob 25s infinite ease-in-out alternate-reverse;
                }
                @keyframes floatBlob {
                    0% { transform: translate3d(0, 0, 0); }
                    100% { transform: translate3d(30px, 30px, 0); }
                }

                /* 2. NEW BACK BUTTON (Modern) */
                .top-nav { position: fixed; top: 90px; left: 20px; z-index: 50; }
                .back-btn-modern {
                    display: flex; align-items: center; gap: 10px;
                    background: rgba(255, 255, 255, 0.9);
                    backdrop-filter: blur(10px);
                    padding: 8px 16px 8px 8px;
                    border-radius: 30px;
                    border: 1px solid rgba(255, 255, 255, 0.8);
                    box-shadow: 0 4px 15px rgba(0,0,0,0.05);
                    cursor: pointer;
                    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
                    color: var(--text-sub);
                    font-weight: 600;
                    font-size: 0.9rem;
                }
                .icon-circle {
                    width: 32px; height: 32px;
                    background: #F3F4F6;
                    border-radius: 50%;
                    display: flex; align-items: center; justify-content: center;
                    color: #1F2937;
                    transition: background 0.2s;
                }
                .back-btn-modern:hover { transform: translateY(-2px); box-shadow: 0 8px 20px rgba(0,0,0,0.08); color: var(--primary); }
                .back-btn-modern:hover .icon-circle { background: #FCE7F3; color: var(--primary); }

                /* HEADER */
                .student-header { text-align: center; margin-bottom: 40px; position: relative; z-index: 10; }
                .icon-wrapper-header { 
                    width: 64px; height: 64px; margin: 0 auto 16px;
                    background: white; border-radius: 24px;
                    display: flex; align-items: center; justify-content: center;
                    color: var(--primary); box-shadow: 0 10px 30px rgba(219, 39, 119, 0.15);
                    transform: rotate(-5deg);
                }
                .student-title { font-size: 2.5rem; font-weight: 900; color: #111827; margin-bottom: 8px; letter-spacing: -0.02em; }
                .highlight { background: linear-gradient(90deg, #EC4899, #8B5CF6); -webkit-background-clip: text; -webkit-text-fill-color: transparent; }
                .subtitle { font-size: 1.1rem; color: var(--text-sub); opacity: 0.9; }

                /* MAIN */
                .student-layout-content { max-width: 900px; margin: 0 auto; position: relative; z-index: 10; }

                /* GLASS CARD */
                .glass-card {
                    background: var(--glass-bg);
                    /* Vẫn giữ blur cục bộ cho đẹp, nhưng nền web giảm blur */
                    border: 1px solid var(--glass-border);
                    border-radius: 30px; /* Bo tròn nhiều hơn */
                    padding: 40px;
                    box-shadow: 0 20px 50px -10px rgba(0,0,0,0.05);
                }

                /* INPUTS */
                .input-wrapper { margin-bottom: 20px; }
                .input-wrapper label { display: block; font-weight: 700; font-size: 0.9rem; margin-bottom: 8px; color: #374151; }
                .required { color: #DC2626; margin-left: 2px; }
                
                input, select, textarea {
                    width: 100%;
                    padding: 14px 18px;
                    border-radius: 16px;
                    border: 2px solid #E5E7EB;
                    background-color: #FFFFFF !important;
                    color: #111827 !important;
                    font-size: 15px; font-weight: 500;
                    outline: none; transition: all 0.2s;
                }
                input:focus, select:focus, textarea:focus {
                    border-color: var(--primary);
                    box-shadow: 0 4px 12px rgba(219, 39, 119, 0.1);
                    transform: translateY(-1px);
                }
                .input-error { border-color: #EF4444; background-color: #FEF2F2 !important; }
                .error-msg { color: #EF4444; font-size: 0.85rem; margin-top: 6px; font-weight: 600; }

                /* TAGS */
                .tags-suggestion { margin-top: 12px; }
                .tags-suggestion p { font-size: 0.85rem; color: #6B7280; margin-bottom: 8px; font-weight: 600; }
                .tags-list { display: flex; flex-wrap: wrap; gap: 8px; }
                .tag-btn {
                    background: white; border: 1px solid #E5E7EB;
                    padding: 6px 12px; border-radius: 20px;
                    font-size: 0.85rem; font-weight: 600; color: #4B5563;
                    cursor: pointer; transition: all 0.2s;
                }
                .tag-btn:hover { background: #FFF0F5; color: var(--primary); border-color: #FBCFE8; transform: scale(1.05); }

                /* SCORE GRID */
                .score-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(100px, 1fr)); gap: 16px; }
                .score-item { background: white; padding: 10px; border-radius: 12px; border: 1px solid #F3F4F6; text-align: center; }
                .score-label { display: block; font-size: 0.8rem; font-weight: 700; color: #6B7280; margin-bottom: 4px; white-space: nowrap; }
                .score-input-field { text-align: center; font-weight: 800; font-size: 1.2rem; color: var(--primary) !important; border: none; background: transparent !important; padding: 4px; height: auto; }
                .score-input-field:focus { box-shadow: none; transform: none; border-bottom: 2px solid var(--primary); border-radius: 0; }

                /* BUTTON MAGIC */
                .action-area { margin-top: 32px; }
                .btn-magic {
                    width: 100%; padding: 18px; border-radius: 20px;
                    background: linear-gradient(135deg, #EC4899 0%, #8B5CF6 100%);
                    color: white; font-size: 1.1rem; font-weight: 800;
                    border: none; cursor: pointer;
                    display: flex; align-items: center; justify-content: center; gap: 10px;
                    box-shadow: 0 10px 25px rgba(236, 72, 153, 0.3);
                    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
                }
                .btn-magic:hover { transform: translateY(-4px) scale(1.01); box-shadow: 0 20px 40px rgba(236, 72, 153, 0.4); }
                .btn-magic:disabled { opacity: 0.7; cursor: not-allowed; transform: none; }
                .spinner { width: 24px; height: 24px; border: 3px solid rgba(255,255,255,0.3); border-top-color: white; border-radius: 50%; animation: spin 1s linear infinite; }

                /* RESULT & OTHERS (Giữ nguyên style result) */
                .analyze-card { background: linear-gradient(135deg, #FFF0F5 0%, #FFFFFF 100%); border-color: #FBCFE8; }
                .analyze-header { display: flex; gap: 16px; margin-bottom: 16px; }
                .emoji-icon { font-size: 2.5rem; background: white; width: 60px; height: 60px; display: flex; align-items: center; justify-content: center; border-radius: 50%; box-shadow: 0 4px 10px rgba(0,0,0,0.05); }
                .tags-container { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; }
                .tag-label { font-weight: 600; font-size: 0.9rem; }
                .tag-block { background: #111827; color: white; padding: 4px 12px; border-radius: 8px; font-weight: 700; font-size: 0.9rem; }
                .section-header-text { font-size: 1.5rem; font-weight: 800; color: #111827; margin-bottom: 20px; }
                .cards-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(260px, 1fr)); gap: 20px; }
                .career-card { background: white; padding: 24px; border-radius: 20px; border: 1px solid #F3F4F6; box-shadow: 0 10px 30px -10px rgba(0,0,0,0.05); transition: transform 0.3s; cursor: default; }
                .career-card:hover { transform: translateY(-8px); border-color: #FBCFE8; box-shadow: 0 20px 40px -10px rgba(236, 72, 153, 0.15); }
                .card-top { display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 12px; }
                .card-icon-circle { width: 48px; height: 48px; background: #FDF2F8; border-radius: 14px; display: flex; align-items: center; justify-content: center; font-size: 1.5rem; }
                .trend-badge { background: #FEF2F2; color: #DC2626; font-size: 0.7rem; font-weight: 800; padding: 4px 8px; border-radius: 6px; border: 1px solid #FECACA; }
                .career-card h4 { font-size: 1.2rem; font-weight: 800; margin: 0 0 8px; color: #111827; }
                .reason { font-size: 0.9rem; color: var(--text-sub); line-height: 1.5; font-style: italic; }
                .card-divider { height: 1px; background: #F3F4F6; margin: 16px 0; }
                .salary-text { font-weight: 700; color: #059669; font-size: 0.95rem; }
                .uni-item { display: flex; gap: 16px; background: white; padding: 20px; border-radius: 16px; border: 1px solid #E5E7EB; margin-bottom: 12px; transition: transform 0.2s; }
                .uni-item:hover { transform: scale(1.01); border-color: var(--secondary); }
                .uni-icon { font-size: 2rem; background: #F5F3FF; width: 56px; height: 56px; border-radius: 12px; display: flex; align-items: center; justify-content: center; }
                .uni-content { flex: 1; }
                .uni-content h4 { font-size: 1.1rem; font-weight: 800; margin: 0 0 4px; color: #111827; }
                .uni-detail { font-size: 0.9rem; color: var(--text-sub); margin-bottom: 8px; }
                .uni-badges { display: flex; gap: 8px; flex-wrap: wrap; }
                .badge-gray { background: #F3F4F6; color: #374151; font-size: 0.8rem; padding: 4px 10px; border-radius: 6px; font-weight: 600; }
                .badge-blue { background: #EFF6FF; color: #2563EB; font-size: 0.8rem; padding: 4px 10px; border-radius: 6px; font-weight: 600; }
                .uni-chance-tag { font-weight: 800; font-size: 0.85rem; padding: 6px 12px; border-radius: 8px; height: fit-content; white-space: nowrap; }
                .chance-safe { background: #ECFDF5; color: #059669; }
                .chance-warning { background: #FFFBEB; color: #D97706; }
                .chance-danger { background: #FEF2F2; color: #DC2626; }
                .roadmap-container { background: #EFF6FF; border-radius: 20px; padding: 30px; border: 2px dashed #BFDBFE; }
                .roadmap-title { font-size: 1.2rem; font-weight: 800; color: #1E3A8A; margin-bottom: 20px; }
                .roadmap-list { list-style: none; padding: 0; }
                .roadmap-list li { display: flex; gap: 12px; margin-bottom: 12px; background: rgba(255,255,255,0.6); padding: 12px; border-radius: 12px; color: #1E40AF; font-weight: 500; }
                .tabs-container { display: flex; justify-content: center; gap: 12px; margin-bottom: 40px; }
                .tab-btn { padding: 12px 24px; border-radius: 99px; border: none; font-weight: 700; cursor: pointer; background: rgba(255,255,255,0.5); color: #6B7280; transition: all 0.3s; font-size: 1rem; }
                .tab-btn.active { background: white; color: var(--primary); box-shadow: 0 4px 15px rgba(219, 39, 119, 0.2); transform: scale(1.05); }
                .hidden { display: none; }
                .block { display: block; }
                .animate-fade-up { animation: fadeUp 0.6s ease-out; }
                .animate-fade-down { animation: fadeDown 0.6s ease-out; }
                @keyframes fadeUp { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
                @keyframes fadeDown { from { opacity: 0; transform: translateY(-20px); } to { opacity: 1; transform: translateY(0); } }
                @keyframes spin { to { transform: rotate(360deg); } }

                @media (max-width: 768px) {
                    .grid-2 { grid-template-columns: 1fr; }
                    .score-grid { grid-template-columns: 1fr 1fr; }
                    .title { font-size: 1.8rem; }
                    .back-btn-modern { top: 80px; }
                }
            `}</style>
        </div>
    );
}

// Helpers
function getSubjectName(key) {
    const map = {
        math: 'Toán', literature: 'Ngữ Văn', english: 'Tiếng Anh',
        physics: 'Vật Lý', chemistry: 'Hóa Học', biology: 'Sinh Học',
        history: 'Lịch Sử', geography: 'Địa Lý'
    };
    return map[key] || key;
}

function getSubjectEmoji(key) {
    const map = {
        math: '📐', literature: '📚', english: '🇬🇧',
        physics: '⚡', chemistry: '🧪', biology: '🧬',
        history: '🏛️', geography: '🌍'
    };
    return map[key] || '📝';
}

function getChanceClass(text) {
    if (!text) return '';
    if (text.includes('Cao') || text.includes('An toàn')) return 'chance-safe';
    if (text.includes('Rủi ro') || text.includes('Thấp')) return 'chance-danger';
    return 'chance-warning';
}